var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDanceRightImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 127,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m186.632 67.113-6.903 3.985L183.715 78l6.902-3.985-3.985-6.902Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.137 52.854-3.715-1.456-1.456 3.715 3.715 1.456 1.456-3.715ZM2.36 101.05c-.31 0-.61-.12-.84-.35-.47-.47-.47-1.22 0-1.69l2.19-2.19a1.19 1.19 0 0 1 1.69 0c.47.47.47 1.22 0 1.69l-2.19 2.19c-.24.23-.54.35-.85.35Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.259 94.17a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.65 6.26-33.171 19.15M150.859 4.13l-16.54 16.54",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.959 39.85c7.682 0 13.91-6.227 13.91-13.91 0-7.682-6.228-13.91-13.91-13.91-7.683 0-13.91 6.228-13.91 13.91 0 7.683 6.227 13.91 13.91 13.91Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.839 37.91c7.682 0 13.91-6.228 13.91-13.91s-6.228-13.91-13.91-13.91c-7.683 0-13.91 6.228-13.91 13.91s6.227 13.91 13.91 13.91Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.828 29.07c4.87.83 9.49-2.44 10.33-7.31",
    stroke: "#FFC078",
    strokeWidth: 1.219,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.209 23.18a.87.87 0 1 0 0-1.741.87.87 0 0 0 0 1.74ZM182.929 16.51a.87.87 0 1 0 0-1.741.87.87 0 0 0 0 1.74Z",
    fill: "#FFC078",
    stroke: "#FFC078",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.139 77.45c1.2.88 2.62 1.43 4.06 1.84 3.3.93 6.9 1.12 10.13-.04 3.23-1.16 6.02-3.8 6.83-7.14.81-3.34-.71-7.24-3.8-8.73-1.8-.86-3.92-.88-5.85-.38-.96.24-1.9.62-2.64 1.27-2.32 2.05-1.55 6.18.87 8.11 2.43 1.93 5.82 2.12 8.88 1.67 2.77-.41 5.64-1.36 7.42-3.53.92-1.12 1.48-2.48 1.88-3.87.88-3.06 1.01-6.43-.17-9.39-1.04-2.61-3.19-4.84-5.83-5.7",
    stroke: "#FFA940",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.249 50.41-2.06 1.23 1.23 2.06-1.39-.35-1.23-2.06 2.06-1.23 1.39.35Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197.929 45.9-6.92.26c-4.68 2.27-8.78 2.99-12.82 2.98-28.19-.14-45.19-22.14-84.25-29.81-25.02-4.91-43.62 5.55-62.74 23.95-14.31 13.78-24.94 25.66-25.24 26.29l4.85 2.69c.27-.58 27.4-55.45 82.19-47.76 32 4.5 61 37.5 104.93 21.4Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.049 1.25 12.1 20.88M188.999 96.94l-23.811-10.41M169.634 112.983l-3.985-1.561-1.561 3.985 3.985 1.561 1.561-3.985ZM153.579 90.67l-5.35-3.78-.59 6.52 5.94-2.74ZM26.509 111.61l42.71-16.85M54.07 88.23l15.33-.85",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.749 64.89s21.22 24.89 53.81 3.87",
    stroke: "#FFA940",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.76 71.24.53-2.34-2.34-.53 1.22-.77 2.34.53-.53 2.34-1.22.77Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.989 28-3.08-16.62s1.66-.92 2.05-3.51l4.53-3.02c-.5-1.01-2.52.94-4.02 1.01-.72.03-1.33-1.79-1.33-1.79-.61-3.05-1.18-3.74-1.18-3.74s-2.01-1.01-1.01.5c0 0-.86.19-.21 5.28l-.65 3.44 1.12 16.55-2.34 16.36s4.88 6.09 8.53 4.88c0 0-1.22-7.01-1.22-9.75 0-3.33-1-8.65-1.19-9.59ZM111.78 45.3l5.6 7.18-4.47 4.17-7.92-.78-1.22-7.32 2.049-2.68 5.961-.57ZM104.989 96.09c-5.36.99-16.05 2.94-21.71 2.31-9.05-1.01-9.05-8.55-11.57-16.09-2.51-7.54-7.54-12.07-7.54-12.07l-8.57-8.2c-.31-.36-.48-.82-.48-1.29 0-.96.34-1.05.95-1.09 1.04-.08 2.08.12 3.02.59 2.38 1.18 6.55 3.26 6.78 3.4l5.06 1.2c1.32.79 1.85 2.44 1.25 3.85l-.45 1.05 1.51 2.51C83.8 83.32 84.3 89.36 84.3 89.36c1.35-.79 2.82-1.42 4.29-1.93M127.279 97.15l-6.79 11.31-3.73.31c-1.31.11-2.31 1.2-2.31 2.51l1.88 2.83c0 1.66-1.21 10.97.03 12.07.26.23.48.38.61.38.5 0 1.51-1.01 1.51-1.01l4.02-11.57s4.02-7.54 9.05-11.57c5.03-4.02 10.35-7.02 10.06-11.06-.11-1.61-1.24-2.78-2.9-3.64",
    fill: "#FFD8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.919 76.25-21.03 5.26s-.47 2.6 1.68 5.9c2.35 3.61 7.81 8.06 20.4 10.92 23.13 5.26 31.55-13.67 31.55-13.67l-18.78-4.63c0 .01-8.56 5.69-13.82-3.78Z",
    fill: "#FF922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.609 89.92 8.42-9.46M125.8 93.08l-7.361-11.57M113.18 86.77l1.05-5.26M97.41 82.56l11.559-4.2M129.999 85.72l-8.41-5.26",
    stroke: "#FFC078",
    strokeWidth: 1.219,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.519 56.02-4.75-7.47-4.88-2.44s2.31 4.33 0 6.09c-2.31 1.76-6.09-3.66-6.09-3.66s4.33 12.47 12.52 19.64c0 0 4.31 5.28 2.6 8.06-.91 1.48 1.09 3.21 3.15 4.5 2.72 1.7 6.14 2 9.02.58.5-.25 1.01-.54 1.5-.88l2.14-5.97s2.53-14.71-2.14-19.55c-1.38-1.43-2.44-3.13-2.79-5.08l-.41-3.74-6.09-4.88v6.09l3.66 6.09-.89.89c-.99.99-2.33 1.57-3.74 1.62l-2.81.11Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.109 44.01s2.85-5.46-1.17-9.49c-4.02-4.02-9.09-1.39-10.06 1.51-1.51 4.53 1.02 14.22 6.04 14.65 5.03.44 5.03-6.6 5.03-6.6",
    fill: "#FFE8CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.75 22.4-2-3.47-3.02-2.51s-2.01-1.01-3.02-3.02c0 0-.55-1.28-.84-1.99-.08-.19-.34-.2-.42-.01-.32.68-.68 2.07.76 3.51l-5.1-.42c-.16-.01-.22.21-.07.27l4.66 2.16s-1.51 0-3.51-.26c-.08-.01-.13.06-.06.11.79.57 2.46 1.62 3.57 1.21 0 0-.57.57-2.21.85-.3.05-.36.45-.09.59.63.33 1.63.64 2.81.23 0 0 1.08 2.45 5.15 3.79l12.95 21.14c1.57 6.39 5.74 11.89 8.66 8.3 2.919-3.59-.62-6.42-.62-6.42l-8.44-13.99-9.16-10.07Z",
    fill: "#FFD8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.43 42.07 2.35-.84M106.659 42.07l-2.67-.42M106.959 47.44s.67.67 1.68.67c1.01 0 1.45-1.1 1.45-1.1",
    stroke: "#FFC078",
    strokeWidth: 0.609,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.809 41.86s-2.66-.29-2.05 1.22c.61 1.51 1.12 3.02 2.13 3.02",
    fill: "#FFE8CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.59 41.23s.72-6.19 6.93-5.52c0 0 4.64.86 5.43 5.64 0 0 1.48-7.89-6.18-8.87-7.66-.98-6.18 8.75-6.18 8.75Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.039 33.93a1.83 1.83 0 1 0 0-3.66 1.83 1.83 0 0 0 0 3.66Z",
    fill: "#FFA940"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanceRightImage);
export default __webpack_public_path__ + "static/media/danceRightImage.4d1e7dacb24c1e7e435218fcf9b0e694.svg";
export { ForwardRef as ReactComponent };